<template>
  <div id="add-img-btn">
    <!-- 上傳 -->
    <q-uploader ref="qUploader" accept=".jpg, .JPG, .jpeg, .JPEG, .png, .PNG, .mp4, .MP4, .mov, .MOV" class="plusBtn" url="" multiple max-files="9" max-file-size="10485760">
      <template v-slot:header="scope">
        <div>
          <q-spinner v-if="scope.isUploading" class="q-uploader__spinner" />
        </div>
      </template>
      <!-- 預覽圖片列表 -->
      <template v-slot:list="scope">
        <q-list class="upload-list">
          <div v-if="scope.canAddFiles" class="upload-btn-div">
            <q-btn class="upload-btn" type="a" icon="fal fa-plus" unelevated color="border-grey" text-color="lale-t-grey"><q-uploader-add-trigger /></q-btn>
          </div>
          <div class="preview-item" v-for="file in scope.files" :key="file.name">
            <img v-if="file.__img" thumbnail :src="file.__img.src" />
            <img v-if="isVideo(file.name)" src="@/assets/img/video.svg" class="default-video" />
            <q-item-section class="remove-btn">
              <q-btn size="10px" flat dense round icon="fal fa-times" @click="scope.removeFile(file)" />
            </q-item-section>
          </div>
        </q-list>
      </template>
    </q-uploader>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'AddImgBtn',
  data: function() {
    return {
      albumName: '',
      dense: false,
      amount: 0,
      checkBtn: false
    };
  },
  computed: {
    ...mapState('EditPostModule', ['uploadFiles'])
  },
  methods: {
    ...mapMutations('EditPostModule', ['SET_UPLOAD_FILES']),
    setFile() {
      this.SET_UPLOAD_FILES(this.$refs.qUploader.files);
    },
    // 檢查檔名是否為影片檔
    isVideo(fileName) {
      debugger
      if (fileName.indexOf('.mp4') > -1 || fileName.indexOf('.MP4') > -1 || fileName.indexOf('.mov') > -1 || fileName.indexOf('.MOV') > -1) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/styles/quasar.variables';
#add-img-btn {
  width: 90vw;
  margin: 0 auto;
}
.q-uploader {
  box-shadow: none;
  max-height: initial;
  width: 100%;
}

.upload-list {
  margin: -8px;
}
.plusBtn {
  margin-top: 5vw;
  margin-bottom: 2vw;
}
.upload-btn-div {
  display: inline-block;
  width: 33%;
  height: 0px;
  padding-bottom: 33%;
  position: relative;
}

.upload-btn {
  width: calc(100% - 2px);
  height: 100%;
  position: absolute;
}

.preview-item {
  display: inline-block;
  width: 33%;
  height: 0px;
  padding-bottom: 33%;
  position: relative;
}

.preview-item img {
  width: 100%;
  height: 100%;
  position: absolute;
  object-fit: cover;
  padding: 0 1px;
  border-radius: 3px;
}

.default-video {
  object-fit: initial !important;
}

.remove-btn {
  position: absolute;
  right: 5px;
  top: 5px;
  background-color: #00000033;
  border-radius: 50%;
  color: #fff;
}
</style>
